/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.pageViewModule')
.directive('bulbShare', ['BulbAuthService','BulbUnitService', bulbShare]);

function bulbShare(BulbAuthService, BulbUnitService) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/share/share.html',
    controller: 'ShareController as shareCtrl',
    scope: {
      isPublic: '<',
    },
    link: function(scope, element, attrs) {
      var shareCtrl = scope.shareCtrl;
      shareCtrl.unit = BulbUnitService.currentUnit;
      shareCtrl.currentUser = BulbAuthService.currentUser;
      shareCtrl.isCurrentUserPageAuthor = BulbUnitService.currentUnit.ownerUsername === BulbAuthService.currentUser.username;
    }
  };
}
